import {
  asyncDefaults,
  makeAsyncReducer,
  makeAsyncResetReducer,
  mergeReducers
} from '../../../ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';

const fetchAsset = makeAsyncReducer(types.FETCH_ASSET);

const resetAsset = makeAsyncResetReducer(types.RESET_ASSET, {});

export default mergeReducers(asyncDefaults({}), types.PREFIX, fetchAsset, resetAsset);

export const getAsset = (state) => state.portal.asset.data;
